import { render, staticRenderFns } from "./DrawerItem.vue?vue&type=template&id=2ca8ea47&scoped=true&lang=pug&"
import script from "./DrawerItem.vue?vue&type=script&lang=js&"
export * from "./DrawerItem.vue?vue&type=script&lang=js&"
import style0 from "./DrawerItem.vue?vue&type=style&index=0&id=2ca8ea47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca8ea47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFabTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFabTransition})
